/**
 * ブラウザ判定とクラス付与機能を管理
 *
 * 仕様
 * - browser-samsung: Samsung Internet ブラウザの場合
 * - browser-opera: Opera ブラウザの場合
 * - browser-chrome: Chrome ブラウザの場合（Edge、Operaを除く）
 * - browser-firefox: Firefox ブラウザの場合
 * - browser-safari: Safari ブラウザの場合（Chromeを除く）
 * - browser-edge: Edge ブラウザの場合
 * - browser-ie: Internet Explorer の場合
 * - browser-android: Android デフォルトブラウザの場合
 *
 * 使い方
 * <html>
 *   <!-- このスクリプト実行後、HTML要素に該当するブラウザクラスが付与される -->
 * </html>
 *
 * 呼び出し例
 * BrowserDetector.detect();
 */

export class BrowserDetector {
  /**
   * ブラウザ判定を実行し、document.documentElement に対して該当するクラスを付与します。
   */
  public static detect(): void {
    const ua = window.navigator.userAgent.toLowerCase();
    const html = document.documentElement;

    // Samsung Internet Browser
    if (ua.indexOf('samsungbrowser') !== -1) {
      html.classList.add('browser-samsung');
    }
    // Opera
    else if (ua.indexOf('opr') !== -1 || ua.indexOf('opera') !== -1) {
      html.classList.add('browser-opera');
    }
    // Chrome (Edge や Opera を除外)
    else if (
      ua.indexOf('chrome') !== -1 &&
      ua.indexOf('edge') === -1 &&
      ua.indexOf('opr') === -1
    ) {
      html.classList.add('browser-chrome');
    }
    // Firefox
    else if (ua.indexOf('firefox') !== -1) {
      html.classList.add('browser-firefox');
    }
    // Safari (Chrome ではない場合)
    else if (ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1) {
      html.classList.add('browser-safari');
    }
    // Edge (従来版および Chromium ベース)
    else if (ua.indexOf('edge') !== -1 || ua.indexOf('edg') !== -1) {
      html.classList.add('browser-edge');
    }
    // Internet Explorer
    else if (ua.indexOf('msie') !== -1 || ua.indexOf('trident') !== -1) {
      html.classList.add('browser-ie');
    }
    // Android デフォルトブラウザ
    else if (ua.indexOf('android') !== -1 && ua.indexOf('chrome') === -1) {
      html.classList.add('browser-android');
    }
  }
}
